import { dataHooks } from '../../../../libs/dataHooks';

export const suggestionsDropdown = dataHooks<{
  resultsList: {};
  searchButton: {};
  dropdown: { opened: boolean };
}>('suggestionsDropdown');
